import { Routes, Route, Navigate } from "react-router-dom";
import ContractorCollectionListScreen from "screens/App/CRM/Contractor/ContractorCollectionListScreen";
import { ContractorDashboardScreen } from "screens/App/CRM/Dashboard/ContractorDashboardScreen";
import ContractorShipmentListScreen from "screens/App/CRM/Contractor/ContractorShipmentListScreen";
import ContractorDriverListScreen from "screens/App/CRM/Contractor/ContractorDriverListScreen";
import ContractorVehicleListScreen from "screens/App/CRM/Contractor/ContractorVehicleListScreen"
import DriverCreateScreen from "screens/App/CRM/Driver/DriverCreateScreen";
import VehicleCreateScreen from "screens/App/CRM/Vehicle/VehicleCreateScreen";
import DriverDetailScreen from "screens/App/CRM/Driver/DriverDetailScreen";
import VehicleDetailScreen from "screens/App/CRM/Vehicle/VehicleDetailScreen";
import CollectionDetailScreen from "screens/App/CRM/Collection/CollectionDetailScreen";
import ShipmentDetailScreen from "screens/App/CRM/ShipmentRequest/ShipmentDetailScreen";
import AnnouncementListScreen from "screens/App/CRM/Announcement/AnnouncementListScreen";
import AnnouncementDetailScreen from "screens/App/CRM/Announcement/AnnouncementDetailScreen";

export const ContractorSidebarRouter = () => {
    return (
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<ContractorDashboardScreen />} />
        <Route path="shipments" element={<ContractorShipmentListScreen />} />
        <Route path="shipments/:id/detail" element={<ShipmentDetailScreen />} />
        <Route
          path="myShipments"
          element={<ContractorCollectionListScreen />}
        />
        <Route
          path="myShipments/:id/detail"
          element={<CollectionDetailScreen />}
        />
        <Route path="drivers" element={<ContractorDriverListScreen />} />
        <Route path="vehicles" element={<ContractorVehicleListScreen />} />
        <Route path="driver/create" element={<DriverCreateScreen />} />
        <Route path="driver/:id/detail" element={<DriverDetailScreen />} />
        <Route path="vehicle/create" element={<VehicleCreateScreen />} />
        <Route path="vehicle/:id/detail" element={<VehicleDetailScreen />} />
        <Route path="announcement/list" element={<AnnouncementListScreen />} />
        <Route
          path="announcement/:id/detail"
          element={<AnnouncementDetailScreen />}
        />
      </Routes>
    );
}
